import {
  initialTrendingHashState,
  TrendingHashState
} from '../states/trending-hash.state';
import { Action, createReducer, on } from '@ngrx/store';
import {
  loadHashTag,
  loadHashTagError,
  loadHashTagSuccess
} from '../actions/trending-hashtag.actions';

const reducer = createReducer(
  initialTrendingHashState,

  on(loadHashTag, state => ({
    ...state,
    error: '',
    loading: true,
    trending: []
  })),

  on(loadHashTagSuccess, (state, { trending }) => ({
    ...state,
    loading: false,
    trending: trending.map(t => ({
      ...t,
      hashTag: t.hashTag.split('#')[1]
    }))
  })),

  on(loadHashTagError, (state, { error }) => ({
    ...state,
    loading: false,
    trending: [],
    error
  }))
);

export function trendingHashReducer(
  state: TrendingHashState | undefined,
  action: Action
): TrendingHashState {
  return reducer(state, action);
}
